<template>
  <tr :class="{ 'is-selected': selected, 'hidden-print': !selected }">
    <td class="hidden-print has-text-centered">
      <checkbox v-model="selected" name="selected" />
    </td>
    <td class="has-text-centered" style="maxWidth: 250px">
      <div v-if="item.products.length">
        <p v-for="product in item.products" :key="product.id">
          <router-link
            :to="{ name: 'products.edit', params: { uuid: product.uuid } }"
          >
            <i class="fa fa-angle-double-right" /> {{ product.title }}
          </router-link>
        </p>
      </div>
      <div v-else>Δε βρέθηκαν προϊόντα</div>
    </td>
    <td class="has-text-centered">{{ item.discount }} &#x25;</td>
    <td class="has-text-centered">
      {{ item.expires_at | timestamp('YYYY-MM-DD', 'DD-MM-YYYY') }}
    </td>
    <td v-if="!isDeleted" class="has-text-centered hidden-print">
      <ToggleButton
        :sync="true"
        :value="item.active === true"
        :color="{ checked: '#22A684', unchecked: '#ff3860' }"
        :width="30"
        :height="15"
        disabled
        @change="onChange"
      />
    </td>
    <td class="has-text-centered visible-print">
      {{ item.active === true ? 'Ναί' : 'Όχι' }}
    </td>
    <td class="has-text-centered hidden-print">
      <div class="buttons is-centered">
        <router-link
          :to="{ name: 'marketing.bundles.edit', params: { uuid: item.uuid } }"
          class="button is-small"
        >
          <span class="icon is-small">
            <span class="fa fa-fw fa-pencil" />
          </span>
        </router-link>
        <button v-if="!isDeleted" class="button is-small" @click="onDelete">
          <span class="icon is-small">
            <span class="fa fa-fw fa-trash-o" />
          </span>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import PaginatedListItem from '@/views/components/PaginatedList/components/PaginatedListItem';

export default {
  extends: PaginatedListItem,
};
</script>
